import { defineComponent as _defineComponent } from 'vue'
import { config } from '@/config';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { RouterLink } from 'vue-router';

interface MenuLink {
  text: string;
  link: string;
  icon: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavMenu',
  setup(__props) {

const menuLinks: MenuLink[] = [
  {
    text: 'Dashboard',
    link: '/app/dashboard',
    icon: 'dashboard',
  },
  {
    text: 'Products',
    link: '/app/products',
    icon: 'box',
  },
  {
    text: 'Clients',
    link: '/app/clients',
    icon: 'handshake',
  },
  {
    text: 'Client Trades',
    link: '/app/client-trades',
    icon: 'multiple_stop',
  },
  {
    text: 'Exposure',
    link: '/app/exposure',
    icon: 'visibility',
  },
  ...(config.showDevTools
    ? [
        {
          text: 'Kitchen Sink',
          link: '/app/kitchen-sink',
          icon: 'countertops',
        },
      ]
    : []),
  {
    text: 'Settings',
    link: '/app/settings',
    icon: 'settings',
  },
];

return { __sfc: true,menuLinks, MaterialIcon, RouterLink }
}

})